jQuery(".footer-txt h3").click(function () {
  // Check if the screen width is 767px or less
  if (jQuery(window).width() <= 767) {
    var $nextUl = jQuery(this).next("ul");
    jQuery(this).find(".footer-icon-caret").toggleClass("active");
    if ($nextUl.is(":visible")) {
      // If the ul is visible, animate it to hide
      $nextUl.css("display", "flex").stop(true, true).slideUp();
    } else {
      // If the ul is hidden, animate it to show
      $nextUl.css("display", "flex").stop(true, true).slideDown();
    }
  }
});
jQuery(".close-serach-popup").click(function () {
  jQuery("#search-popup").removeClass("active");
});
jQuery(".js-sidebar .close-btn").click(function () {
  jQuery(".js-sidebar").removeClass("active");
  jQuery(".js-toggle-filter").removeClass("active");
  jQuery("body").removeClass("sidebar-overlay");
});

jQuery(".phone-icon a").click(function () {
  jQuery("body").addClass("contact-overlay-open");
});

jQuery(".need-assistance").click(function () {
  jQuery("body").addClass("contact-overlay-open");
});

jQuery(".close-contact").click(function () {
  jQuery("body").removeClass("contact-overlay-open");
});

jQuery(".modal-underlay").click(function () {
  jQuery("body").removeClass("contact-overlay-open");
  jQuery("body").removeClass("sidebar-overlay");
  jQuery(".js-sidebar").removeClass("active");
});

jQuery(document).ready(function () {
  
  // When a selector wrapper is clicked
  jQuery(".selector-wrapper").on("click", function () {
    var $this = jQuery(this);
    var optionIndex = $this.data("option-name");
    var $sidebar = jQuery("#sidebar-" + optionIndex);
    var optionCount = parseInt($this.data("option-values-count"));
    
    if (
      (optionIndex === "size" && optionCount <= 1) ||
      (optionIndex === "color" && optionCount <= 1) ||
      (optionIndex === "sizes" && optionCount <= 1) ||
      (optionIndex === "colors" && optionCount <= 1)
    ) {
      return;
    }

    // Close any other open sidebars
    jQuery(".product-options-sidebar.open").removeClass("open");
    jQuery("body").addClass("popup-opened");
    // Open the clicked sidebar
    $sidebar.addClass("open");
  });

  jQuery(".select-size-btn").on("click", function () {
    // If button says Notify Me, show email popup
    if (jQuery(this).text().trim() === "Notify Me When Available") {
      jQuery("#cc-notify-popup").css("display", "flex");
      return;
    }
    var $sidebar = jQuery("#sidebar-size");

    // Close any other open sidebars
    jQuery(".product-options-sidebar.open").removeClass("open");
    jQuery("body").addClass("popup-opened");
    // Open the clicked sidebar
    $sidebar.addClass("open");
  });

  // Close the sidebar when a radio button is selected
  jQuery('input[type="radio"]').on("change", function () {
    // Update the selected-value text with chosen option
    var optionName = jQuery(this).data("option-name");
    var optionLabel = jQuery(this).data("option-label");
    if (optionName && optionLabel) {
      jQuery('.selector-wrapper').each(function() {
        if (jQuery(this).data('option-name') === optionName.toLowerCase()) {
          jQuery(this).find('.selected-value').html(optionLabel + ' <i class="fa-solid fa-chevron-right"></i>').css('color', '#330066');
        }
      });
    }
    // Close any open sidebar
    jQuery(".product-options-sidebar.open").removeClass("open");
    jQuery("body").removeClass("popup-opened");
    // Check if selected variant is available
    var selectedRadio = jQuery(this);
    var isDisabled = selectedRadio.closest(".variant-option__option").hasClass("variant-option__option-outofstock_cross");
    
    if (isDisabled) {
      jQuery(".product-form__cart-submit").hide();
      jQuery(".select-size-btn").text("Notify Me When Available").show().prop("disabled", false).removeAttr("disabled").css({"opacity":"1","pointer-events":"auto","cursor":"pointer"});
    } else {
      jQuery(".product-form__cart-submit").show();
      jQuery(".select-size-btn").hide();
    }
  });

  // Close the sidebar when clicking the overlay (outside the sidebar content)
  jQuery(".product-options-sidebar .overlay, .side-close-btn").on(
    "click",
    function (event) {
      // Close the sidebar when the overlay is clicked
      jQuery(".product-options-sidebar.open").removeClass("open");
      jQuery("body").removeClass("popup-opened");
    }
  );
});

function normalize(str) {
  return str.toLowerCase().replace(/\s+/g, '');
}

jQuery(document).ready(function () {

  jQuery('.product-media-images .product-single__photo').each(function(index) {
    var alt = jQuery(this).attr('data-image-alt');
    var selectedColor = jQuery("input[type='radio'][name='color']:checked").val();
    if(alt && selectedColor){
      if(alt.toLowerCase().indexOf(selectedColor.toLowerCase()) === -1){
        jQuery(this).addClass('hide');
        jQuery(this).find('.catarbox').removeAttr('data-fancybox');
      }
    }
    
  });

  jQuery('input[type=radio][name=color]').change(function() {
     var color = this.value;
    jQuery('.product-media-images .product-single__photo').each(function(index) {
    var alt = jQuery(this).attr('data-image-alt');
    var selectedColor = jQuery("input[type='radio'][name='color']:checked").val();
    if(alt && selectedColor){
      if(alt.toLowerCase().indexOf(selectedColor.toLowerCase()) === -1){
        jQuery(this).addClass('hide');
        jQuery(this).find('.catarbox').removeAttr('data-fancybox');
      }else if(alt==selectedColor){
        jQuery(this).removeClass('hide');
        jQuery(this).find('.catarbox').attr('data-fancybox','gallery');
      }
    }
    
  });
  });
  
  // Loop through each product option wrapper
  jQuery(".selector-wrapper.product-form__item").each(function (index) {
    var $optionWrapper = $(this);
    var $optionWrappersidebar = $(this).next(".product-options-sidebar");

    // Select the corresponding select element or radio buttons
    var $select = $optionWrappersidebar.find("select");
    var $radios = $optionWrappersidebar.find('input[type="radio"]');

    // Handle change event for select elements
    if ($select.length) {
      $select.on("change", function () {
        var selectedOptionText = $select.find("option:selected").text();
        $optionWrapper
          .find(".selected-value")
          .html(
            selectedOptionText + ' <i class="fa-solid fa-chevron-right"></i>'
          );
      });
    }

    // Handle change event for radio buttons
    if ($radios.length > 0) {
      $radios.on("change", function () {
        if ($(this).prop("checked")) {
          var bgcolor = $(this).data("option-bgcolor");
          $optionWrapper
            .find(".selected-value")
            .html(
              '<span class="product-swatches__swatch product-swatches__swatch--bg" style="--bg: ' +
                bgcolor +
                '"></span>' +
                $(this).val() +
                ' <i class="fa-solid fa-chevron-right"></i>'
            );
        }
      });
    }
  });
});

function copyToClipboard(button) {
  // Get the URL from the button's data attribute
  var urlToCopy = button.closest(".share-icon").getAttribute("data-copy-url");

  // Create a temporary input element to copy the text
  var tempInput = document.createElement("input");
  tempInput.value = urlToCopy;
  document.body.appendChild(tempInput);

  // Select and copy the text inside the input
  tempInput.select();
  document.execCommand("copy");

  // Remove the temporary input element
  document.body.removeChild(tempInput);

  // Show the "Link Copied!" message
  var notify = button
    .closest(".share-icon")
    .querySelector(".share-icon__notify");
  notify.style.display = "block";

  // Hide the message after 2 seconds
  setTimeout(function () {
    notify.style.display = "none";
  }, 2000);
}

var swiper = new Swiper(".swiper-container", {
  slidesPerView: 1.25, // Show 3 and a half slides
  spaceBetween: 16, // Space between slides
  loop: true,
  freeMode: true, // Loop the slides
  autoplay: {
    delay: 5000, // Auto slide transition every 5 seconds
  },
  navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  },
  pagination: false,
  breakpoints: {
    768: {
      slidesPerView: 2.6, // 3 slides on tablets
      spaceBetween: 32,
    },
    1024: {
      slidesPerView: 3.4, // 2 slides on mobile
      spaceBetween: 40,
    },
    1440: {
      slidesPerView: 3.4, // 1 slide on very small screens
      spaceBetween: 40,
    },
  },
});

var swiper = new Swiper(".js-crosssell-swiper", {
  slidesPerView: 1.25, // Show 3 and a half slides
  spaceBetween: 16, // Space between slides
  loop: true,
  freeMode: true, // Loop the slides
  autoplay: {
    delay: 5000, // Auto slide transition every 5 seconds
  },
  navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
  },
  pagination: false,
  breakpoints: {
    768: {
      slidesPerView: 2.6, // 3 slides on tablets
      spaceBetween: 32,
    },
    1024: {
      slidesPerView: 3.4, // 2 slides on mobile
      spaceBetween: 40,
    },
    1440: {
      slidesPerView: 3.4, // 1 slide on very small screens
      spaceBetween: 40,
    },
  },
});

jQuery(".js-toggle-cart").on("click", function () {
  jQuery(".mini-cart-wapper").addClass("active");
});

jQuery(".mini-cart-wapper .close, .mini-cart-wapper .overlay").on(
  "click",
  function () {
    jQuery(".mini-cart-wapper").removeClass("active");
  }
);

// Open the popup and show the active tab
function openPopup(activeTab) {
  // Show the popup wrapper and activate the popup and overlay with animation
  document.getElementById("popup-wrapper").classList.add("active");
  jQuery("body").addClass("active-info-popup");

  // Automatically show the selected tab
  changeTab(activeTab);
}

// Close the popup
function closePopup() {
  // Hide the popup wrapper, popup, and overlay with animation
  document.getElementById("popup-wrapper").classList.remove("active");
  jQuery("body").removeClass("active-info-popup");
}

// Change tab inside the popup
function changeTab(tabName) {
  // Hide all tabs
  const tabs = document.querySelectorAll(".tab-content");
  tabs.forEach((tab) => {
    tab.classList.remove("active");
  });

  // Remove 'active' class from all tab buttons
  const tabButtons = document.querySelectorAll(".tab-button");
  tabButtons.forEach((button) => {
    button.classList.remove("active");
  });

  // Show the selected tab and activate its button
  const activeTab = document.getElementById(tabName);
  const activeButton = document.querySelector(
    `button[onclick="changeTab('${tabName}')"]`
  );

  activeTab.classList.add("active");
  activeButton.classList.add("active");
}
$(document).ready(function() {
  $('.product-slider-item a').each(function() {
   $(this).attr('tabindex', '-1');
  });
  $('.slick-dots li button').each(function() {
   $(this).attr('tabindex', '-1');
    $(this).attr('aria-label', 'slide dote');
    
  });
 $('.slick-dots li').each(function() {
   $(this).removeAttr('aria-selected');
   $(this).removeAttr('aria-controls');
    
  });
  
 
  $('.slick-track[role="listbox"]').each(function() {
    $(this).attr('aria-label', 'slide image');
  });
   
   $('.productlist-wrapper .slick-dots').attr('role', 'group');
  $('.productlist-wrapper .slick-dots').attr('aria-label', 'Slide navigation');
  $('.productlist-wrapper .slick-dots li button').attr('aria-label', 'slide ');

  $('.slick-dots').attr('role', 'group');
  $('.slick-dots li[role="presentation"]').removeAttr('role');
  $('.slick-track[role="listbox"] .slick-slide').each(function() {
    if (!$(this).attr('role')) {
      $(this).attr('role', 'option');
    }
  });
  $(document).on('click', '.sizechart-close', function() {
    alert('display');
    $('#sizeChartModal').css('display', 'none');
  });

});




// Fix Avada Cookie Bar close button
(function() {
  var fixed = false;
    function fixAvadaCloseButton() {
        if (fixed) return;
            var closeBtn = document.querySelector('.CookiesBar-Pop__Close');
                var cookieBar = document.querySelector('#Avada-CookiesBar');
                    if (closeBtn && cookieBar) {
                          fixed = true;
                                closeBtn.addEventListener('click', function(e) {
                                        e.stopPropagation();
                                                cookieBar.style.display = 'none';
                                                      }, true);
                                                          }
                                                            }
                                                              var interval = setInterval(function() {
                                                                  fixAvadaCloseButton();
                                                                      if (fixed) clearInterval(interval);
                                                                        }, 200);
                                                                          setTimeout(function() { clearInterval(interval); }, 10000);
                                                                          })();

/* === Binnenste product-foto-slider niet mee laten swipen met de productcarrousel (18 sep 2026) === */
(function () {
  if (!window.jQuery) return;
  var $ = window.jQuery;
  function lockInnerSliders() {
    $('.product-image-slider.slick-initialized').each(function () {
      try {
        $(this).slick('slickSetOption', 'swipe', false, false);
        $(this).slick('slickSetOption', 'touchMove', false, false);
        $(this).slick('slickSetOption', 'draggable', false, false);
      } catch (e) {}
    });
  }
  $(document).ready(function () {
    lockInnerSliders();
    $(document).on('ajaxComplete', lockInnerSliders);
    $(document).on('shown.bs.tab', function () { setTimeout(lockInnerSliders, 50); });
    var t = 0, iv = setInterval(function () { lockInnerSliders(); if (++t > 40) clearInterval(iv); }, 300);
  });
})();

/* === MOBIEL PDP stap 2: size-kaart bottom-sheet (<=767px) — 30 sep 2026 === cc-mobile-sizecard */
(function(){
  function init(){
    if(window.__ccSizeCard) return;
    var fs = document.querySelector('fieldset.single-option-radio[name="size"]');
    var ssb = document.querySelector('.select-size-btn');
    if(!fs || !ssb) return;
    window.__ccSizeCard = true;

    // voorraad-map (Liquid) — key = maatwaarde
    var INV = {};
    try{ var mel=document.getElementById('cc-inv-map'); if(mel) INV = JSON.parse(mel.textContent||'{}'); }catch(e){}

    // maten uit de echte opties
    var opts = [].slice.call(fs.querySelectorAll('.variant-option__option')).map(function(o){
      var input = o.querySelector('input[type=radio]');
      var val = input ? input.value : ((o.querySelector('.variant-option__title')||{}).textContent||'').trim();
      var soldClass = /outofstock_cross/.test(o.className);
      var inv = INV[val] || {};
      var available = ('available' in inv) ? !!inv.available : !soldClass;
      var qty = (inv.qty===undefined || inv.qty===null) ? null : inv.qty;
      return { val:val, input:input, available:available, qty:qty };
    });

    // size-label P verbergen op mobiel
    [].forEach.call(document.querySelectorAll('.variant-label'), function(p){
      if(/^\s*Size/i.test(p.textContent||'')) p.setAttribute('data-cc-hide-mob','1');
    });

    // body pill — in de ZICHTBARE flow plaatsen (niet in het off-canvas size-paneel)
    var pill = document.createElement('div');
    pill.className='cc-size-pill';
    pill.innerHTML='<span class="cc-size-pill__txt">Select size</span><span class="cc-size-pill__chev">&#9662;</span>';
    var wraps=[].slice.call(document.querySelectorAll('.selector-wrapper, .product-form__item'));
    var sizeTrigger=null, colorTrigger=null;
    wraps.forEach(function(w){
      var t=((w.innerText||'').trim());
      if(!sizeTrigger && /^Size\b/i.test(t) && !w.querySelector('.product-form__cart-submit,.select-size-btn')) sizeTrigger=w;
      if(!colorTrigger && /^Colou?r\b/i.test(t)) colorTrigger=w;
    });
    if(sizeTrigger){
      sizeTrigger.parentNode.insertBefore(pill, sizeTrigger);
      sizeTrigger.setAttribute('data-cc-hide-mob','1');
      sizeTrigger.style.setProperty('display','none','important');
    } else if(colorTrigger){
      colorTrigger.parentNode.insertBefore(pill, colorTrigger.nextSibling);
    } else {
      var meta=document.querySelector('.product-single__meta');
      if(meta){ meta.parentNode.insertBefore(pill, meta.nextSibling); }
      else { fs.parentNode.insertBefore(pill, fs); }
    }

    // sheet
    var back=document.createElement('div'); back.className='cc-size-backdrop';
    var sheet=document.createElement('div'); sheet.className='cc-size-sheet';
    var rows = opts.map(function(o){
      var meta='';
      if(!o.available){ meta='<span class="cc-size-row__notify"><s>Sold out</s> &middot; Notify me</span>'; }
      else if(o.qty!=null && o.qty>0 && o.qty<=6){ meta='<span class="cc-size-row__meta is-low">Only '+o.qty+' left</span>'; }
      return '<button type="button" class="cc-size-row'+(o.available?'':' is-soldout')+'" data-size="'+String(o.val).replace(/"/g,'&quot;')+'">'+
        '<span class="cc-size-row__name">'+o.val+'</span>'+
        (o.available?'<span class="cc-size-row__ball"></span>':'')+
        meta +
      '</button>';
    }).join('');
    var rulerSvg='<svg class="cc-ruler" viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="#6d6a77" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="8" width="19" height="8" rx="1.5" fill="none"></rect><path d="M6 8v3" fill="none"></path><path d="M9.5 8v4" fill="none"></path><path d="M13 8v3" fill="none"></path><path d="M16.5 8v4" fill="none"></path><path d="M20 8v3" fill="none"></path></svg>';
    sheet.innerHTML='<div class="cc-size-sheet__grip"></div>'+
      '<div class="cc-size-sheet__head"><span class="cc-size-sheet__title">Size</span>'+
      '<button type="button" class="cc-size-sheet__close" aria-label="Close">&times;</button></div>'+
      '<div class="cc-size-sheet__list">'+rows+'</div>'+
      '<button type="button" class="cc-size-sheet__foot">'+
        '<span class="cc-size-sheet__chart">'+rulerSvg+'<span>Size chart</span></span>'+
        '<span class="cc-size-sheet__fit">True to size</span>'+
      '</button>';
    document.body.appendChild(back); document.body.appendChild(sheet);
    // Size chart in de kaart opent de bestaande maattabel-sidebar
    sheet.querySelector('.cc-size-sheet__foot').addEventListener('click', function(){
      var l=document.querySelector('.cc-sizeguide-sidebar-link'); if(l){ l.click(); }
    });

    function openSheet(){ back.classList.add('is-open'); sheet.classList.add('is-open'); document.documentElement.style.overflow='hidden'; }
    function closeSheet(){ back.classList.remove('is-open'); sheet.classList.remove('is-open'); document.documentElement.style.overflow=''; }

    pill.addEventListener('click', function(e){ e.preventDefault(); openSheet(); });
    ssb.addEventListener('click', function(e){ e.preventDefault(); e.stopPropagation(); openSheet(); }, true);
    back.addEventListener('click', closeSheet);
    sheet.querySelector('.cc-size-sheet__close').addEventListener('click', closeSheet);

    function relabel(){
      var cart=document.querySelector('.product-form__cart-submit');
      if(ssb && !/Add to bag/i.test(ssb.textContent)) ssb.textContent='Add to bag';
      if(cart && !/Add to bag/i.test(cart.textContent)) cart.textContent='Add to bag';
    }
    relabel();

    [].forEach.call(sheet.querySelectorAll('.cc-size-row'), function(row){
      row.addEventListener('click', function(){
        var size=row.getAttribute('data-size');
        var o=null; for(var i=0;i<opts.length;i++){ if(String(opts[i].val)===size){ o=opts[i]; break; } }
        if(!o) return;
        if(!o.available){
          if(typeof window.ccNotifySize==='function'){ window.ccNotifySize(size); }
          closeSheet(); return;
        }
        var lbl = o.input ? document.querySelector('label[for="'+o.input.id+'"]') : null;
        if(lbl){ lbl.click(); }
        else if(o.input){ o.input.checked=true; o.input.dispatchEvent(new Event('change',{bubbles:true})); }
        [].forEach.call(sheet.querySelectorAll('.cc-size-row'), function(r){ r.classList.remove('is-selected'); });
        row.classList.add('is-selected');
        pill.classList.add('is-picked');
        var t=pill.querySelector('.cc-size-pill__txt'); if(t) t.textContent='Size '+size;
        setTimeout(relabel, 60);
        setTimeout(closeSheet, 170);
      });
    });
  }
  function maybe(){ if(window.matchMedia('(max-width:767px)').matches) init(); }
  if(document.readyState!=='loading') maybe(); else document.addEventListener('DOMContentLoaded', maybe);
  try{ var mq=window.matchMedia('(max-width:767px)'); if(mq.addEventListener) mq.addEventListener('change', maybe); else if(mq.addListener) mq.addListener(maybe); }catch(e){}
  setTimeout(maybe, 1200); setTimeout(maybe, 3000);
})();

/* === Notify Me herstel: ontbrekende ccNotifySize() definiëren — 30 sep 2026 === cc-notify-fn */
(function(){
  if(window.ccNotifySize) return;
  window.ccNotifySize = function(size){
    var pop = document.getElementById('cc-notify-popup');
    if(!pop){ return; }
    var v = pop.querySelector('.cc-notify-variant');
    if(!v){ v = document.createElement('span'); v.className='cc-notify-variant'; v.style.display='none'; pop.appendChild(v); }
    v.textContent = size ? String(size) : '';
    pop.style.display = 'flex';
  };
})();

/* === MOBIEL PDP stap 4: inline accordions (<=767px) — 30 sep 2026 === cc-mobile-accordions */
(function(){
  function init(){
    if(window.__ccAcc) return;
    if(!window.matchMedia('(max-width:767px)').matches) return;
    var infoWrap = document.querySelector('.product-single__info-wrapper') || document.querySelector('.product-details__form-wrapper');
    if(!infoWrap) return;
    window.__ccAcc = true;

    // bronnen
    var srcTable = document.querySelector('#size-guide table') || document.querySelector('#sizeChartModal');
    var srcBullets = null;
    [].forEach.call(document.querySelectorAll('ul'), function(u){
      if(!srcBullets && /true to size|Model wears|Machine wash/i.test(u.innerText||'')) srcBullets=u;
    });
    var material='';
    try{
      var ld=[].slice.call(document.querySelectorAll('script[type="application/ld+json"]'))
        .map(function(s){return s.textContent;}).filter(function(t){return t.indexOf('"material"')>-1;})[0];
      if(ld){ material=(JSON.parse(ld).material)||''; }
    }catch(e){}

    // Size & fit
    var sizeInner='';
    if(srcTable){
      var scH4=document.querySelector('#size-guide h4, #sizeChartModal h4');
      if(scH4 && (scH4.textContent||'').trim()){ sizeInner += '<div class="cc-sizechart-title">'+scH4.textContent.trim()+'</div>'; }
      sizeInner += '<div class="cc-acc__unit"><button type="button" class="is-active" data-unit="cm">CM</button><button type="button" data-unit="in">INCH</button></div>';
      sizeInner += '<div class="cc-acc__table-scroll">'+srcTable.outerHTML+'</div>';
    }
    if(srcBullets){ sizeInner += '<ul>'+srcBullets.innerHTML+'</ul>'; }
    if(!sizeInner){ sizeInner='<p>Fits true to size and cut with a regular fit. If you are between sizes, we recommend sizing up.</p>'; }

    // Shipping & returns: gebruik de ECHTE officiële thema-tekst (Delivery/Duties/Payment) incl. interne link
    var shipSrc=[].slice.call(document.querySelectorAll('.tab-content, .tab-pane')).filter(function(t){
      return /DHL Express|complimentary worldwide|Payment Methods/i.test(t.innerText||'');
    })[0];
    var shipInner = (shipSrc && shipSrc.innerHTML.trim())
      ? shipSrc.innerHTML
      : '<p>Complimentary worldwide shipping with DHL Express. Orders placed before 3PM CEST are typically dispatched the same day.</p>'+
        '<p>Returns are accepted within 14 days of delivery. For details, see our <a href="/pages/shipping-returns">Shipping &amp; Returns page</a>.</p>';

    var careInner='<p>Machine wash cold at 30&deg;C on a gentle cycle with like colours. Wash inside out to protect the finish.</p>'+
      '<p>Do not bleach. Do not tumble dry. Reshape and lay flat or hang to dry. Do not iron any print.</p>'+
      '<p>Avoid fabric softener to preserve the four-way stretch and shape retention.</p>';

    var matInner='';
    if(material){ matInner += '<p><span class="cc-acc__material">'+material+'</span></p>'; }
    matInner += '<p>Engineered from a premium nylon and elastane blend for a second-skin feel, squat-proof opacity and lasting shape retention.</p>'+
      '<p>Produced in small batches to limit overstock and waste. Every piece is quality checked before it is packed and shipped.</p>';

    var items=[
      {t:'Size &amp; fit', h:sizeInner},
      {t:'Shipping &amp; returns', h:shipInner},
      {t:'Care instructions', h:careInner},
      {t:'Materials &amp; transparency', h:matInner}
    ];
    var wrap=document.createElement('div'); wrap.className='cc-acc-wrap';
    wrap.innerHTML=items.map(function(it){
      return '<div class="cc-acc"><button type="button" class="cc-acc__head">'+it.t+'<span class="cc-acc__sign">+</span></button>'+
        '<div class="cc-acc__panel"><div class="cc-acc__panel-inner">'+it.h+'</div></div></div>';
    }).join('');
    // plaats direct onder de maatkeuze/koopknop (niet onderaan de kolom)
    var accAnchor=document.querySelector('.product-delivery-text')
              || document.querySelector('.product-form')
              || document.querySelector('.product-form__item--submit');
    if(accAnchor && accAnchor.parentNode){ accAnchor.parentNode.insertBefore(wrap, accAnchor.nextSibling); }
    else { infoWrap.appendChild(wrap); }

    // open/close
    [].forEach.call(wrap.querySelectorAll('.cc-acc__head'), function(head){
      head.addEventListener('click', function(){
        var acc=head.parentElement, panel=head.nextElementSibling;
        if(acc.classList.contains('is-open')){ acc.classList.remove('is-open'); panel.style.maxHeight='0'; }
        else { acc.classList.add('is-open'); panel.style.maxHeight=panel.scrollHeight+60+'px'; }
      });
    });

    // cm/inch toggle
    var unitBtns=wrap.querySelectorAll('.cc-acc__unit button');
    var tbl=wrap.querySelector('.cc-acc__table-scroll table');
    if(unitBtns.length && tbl){
      [].forEach.call(tbl.querySelectorAll('td, th'), function(cell){
        var txt=cell.textContent.replace(/["″”“]/g,'').trim();
        if(/\d/.test(txt) && !/^(SIZE|WAIST|HIP|BUST|CHEST|LENGTH|INSEAM|THIGH)$/i.test(txt)){
          cell.setAttribute('data-cm', txt);
          cell.textContent=txt;
        }
      });
      function render(unit){
        [].forEach.call(tbl.querySelectorAll('[data-cm]'), function(cell){
          var base=cell.getAttribute('data-cm');
          cell.textContent = (unit==='cm') ? base
            : base.replace(/-?\d+(\.\d+)?/g, function(n){ return (parseFloat(n)/2.54).toFixed(1); });
        });
      }
      [].forEach.call(unitBtns, function(b){
        b.addEventListener('click', function(){
          [].forEach.call(unitBtns,function(x){x.classList.remove('is-active');});
          b.classList.add('is-active');
          render(b.getAttribute('data-unit'));
          var acc=b.closest('.cc-acc');
          if(acc && acc.classList.contains('is-open')){ var p=acc.querySelector('.cc-acc__panel'); p.style.maxHeight=p.scrollHeight+80+'px'; }
        });
      });
      render('cm');
    }
  }
  function maybe(){ if(window.matchMedia('(max-width:767px)').matches) init(); }
  if(document.readyState!=='loading') maybe(); else document.addEventListener('DOMContentLoaded', maybe);
  try{ var mq=window.matchMedia('(max-width:767px)'); if(mq.addEventListener) mq.addEventListener('change', maybe); }catch(e){}
  setTimeout(maybe,1400); setTimeout(maybe,3200);
})();

/* === MOBIEL PDP stap 5: Key features uit beschrijving-ul (<=767px) — 30 sep 2026 === cc-mobile-keyfeatures */
(function(){
  function init(){
    if(window.__ccKeyFeat) return;
    if(!window.matchMedia('(max-width:767px)').matches) return;
    var infoWrap=document.querySelector('.product-single__info-wrapper')||document.querySelector('.product-details__form-wrapper');
    if(!infoWrap) return;
    // vind feature-ul(len) in de beschrijving
    var matches=[];
    [].forEach.call(document.querySelectorAll('ul'), function(u){
      var t=u.innerText||'';
      if(/squat-?proof/i.test(t) && /(Signature|seamless|waistband|contour|stretch)/i.test(t)
         && !u.closest('.cc-keyfeat') && !u.closest('.cc-acc-wrap')) matches.push(u);
    });
    if(!matches.length) return;
    window.__ccKeyFeat=true;
    var src=matches[0];
    var lis=[].slice.call(src.querySelectorAll('li')).map(function(li){return li.innerHTML.trim();})
      .filter(function(h){ return !/nylon|elastane|spandex|polyester|cotton/i.test(h); });
    var block=document.createElement('div'); block.className='cc-keyfeat';
    block.innerHTML='<div class="cc-keyfeat__title">Key features</div><ul>'+lis.map(function(h){return '<li>'+h+'</li>';}).join('')+'</ul>';
    // verberg alle originele feature-ul's op mobiel (voorkomt dubbeling)
    matches.forEach(function(u){ u.classList.add('cc-desc-ul-hidden'); });
    var accWrap=document.querySelector('.cc-acc-wrap');
    if(accWrap && accWrap.parentNode){ accWrap.parentNode.insertBefore(block, accWrap.nextSibling); }
    else { infoWrap.appendChild(block); }
  }
  function maybe(){ if(window.matchMedia('(max-width:767px)').matches) init(); }
  if(document.readyState!=='loading') maybe(); else document.addEventListener('DOMContentLoaded', maybe);
  try{ var mq=window.matchMedia('(max-width:767px)'); if(mq.addEventListener) mq.addEventListener('change', maybe); }catch(e){}
  setTimeout(maybe,1500); setTimeout(maybe,3400);
})();

/* === MOBIEL PDP stap 6: "The details" (<=767px) — 30 sep 2026 === cc-mobile-details */
(function(){
  var COPY={
    leggings:[
      {h:'Sculpted support',p:'Raised contour panels follow the muscle lines to lift, shape and support through every rep and every stride.'},
      {h:'Second-skin comfort',p:'Buttery-soft seamless knit moves with you and stays put, with a high-rise waistband that never digs or gapes.'},
      {h:'Squat-proof',p:'Engineered at full stretch to stay completely opaque, so you can train in any position with total confidence.'}
    ],
    shorts:[
      {h:'Sculpted support',p:'Contour panels shape and lift while a locked-in waistband keeps everything in place through every movement.'},
      {h:'Second-skin comfort',p:'Lightweight seamless fabric feels like nothing on, with zero chafing and a stay-put fit.'},
      {h:'Squat-proof',p:'Tested at full stretch to stay fully opaque, so you can lift and bend with complete confidence.'}
    ],
    top:[
      {h:'Locked-in support',p:'A supportive, sculpted fit that stays in place and moves with you from warm-up to last set.'},
      {h:'Second-skin comfort',p:'Buttery-soft seamless knit sits close to the skin for a smooth, breathable feel all session long.'},
      {h:'Made to move',p:'High-stretch fabric flexes in every direction and recovers its shape, wash after wash.'}
    ],
    def:[
      {h:'Built to perform',p:'Premium technical fabric engineered to support and shape through every movement.'},
      {h:'Second-skin comfort',p:'Buttery-soft seamless knit that moves with you and stays exactly where you put it.'},
      {h:'Made to last',p:'High-stretch fabric that holds its shape and finish, wash after wash.'}
    ]
  };
  function typeInfo(){
    var h=(document.querySelector('.product-single__title,.product-details__title,h1')||{}).textContent||'';
    var t=(h+' '+(document.title||'')+' '+location.pathname).toLowerCase();
    if(/legging/.test(t)) return {key:'leggings', re:/leggings/};
    if(/short/.test(t)) return {key:'shorts', re:/shorts/};
    if(/top|bra|vest|crop|tee|t-shirt|tank/.test(t)) return {key:'top', re:/(top|bra|vest|crop|tee|tank)/};
    return {key:'def', re:null};
  }
  function init(){
    if(window.__ccDetails) return;
    if(!window.matchMedia('(max-width:767px)').matches) return;
    var infoWrap=document.querySelector('.product-single__info-wrapper')||document.querySelector('.product-details__form-wrapper');
    if(!infoWrap) return;
    var srcs=[];
    [].forEach.call(document.querySelectorAll('img'), function(im){
      var s=im.currentSrc||im.getAttribute('src')||im.getAttribute('data-src')||'';
      s=s.split('?')[0].replace(/_(\{width\}|%7[Bb]width%7[Dd])x\./,'_1024x.');
      if(/catar-cottega-/.test(s) && !/(\{width\}|%7[Bb]width)/i.test(s)){ if(srcs.indexOf(s)===-1) srcs.push(s); }
    });
    if(!srcs.length) return; // geen model-shots -> geen blok
    window.__ccDetails=true;
    var ti=typeInfo();
    // huidige kleur-slug (bv. jet-black) om alleen deze kleur te tonen
    var colorSlug='';
    var cl=[].slice.call(document.querySelectorAll('.variant-label')).map(function(p){return p.textContent||'';}).filter(function(t){return /color\s*:/i.test(t);})[0];
    if(cl){ var m=cl.match(/color\s*:\s*(.+)/i); if(m){ colorSlug=m[1].trim().toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,''); } }
    var pool=srcs.slice();
    if(colorSlug){ var byC=pool.filter(function(s){return s.indexOf(colorSlug)>-1;}); if(byC.length) pool=byC; }
    if(ti.re){ var byT=pool.filter(function(s){return ti.re.test(s);}); if(byT.length) pool=byT; }
    if(pool.length<1) pool=srcs.slice();
    var pick;
    if(pool.length>=3){ pick=[pool[0], pool[Math.floor(pool.length/2)], pool[pool.length-1]]; }
    else { pick=pool.slice(); while(pick.length<3) pick.push(pool[pick.length%pool.length]); }
    pick=pick.map(function(u){ return u.replace(/_(120x|180x|240x|360x|480x|540x|720x|\{width\})\./,'_1024x.'); });
    var copy=COPY[ti.key]||COPY.def;
    var block=document.createElement('div'); block.className='cc-details';
    var inner='<div class="cc-details__title-main">The details</div>';
    for(var i=0;i<3;i++){
      inner+='<div class="cc-details__block">'+
        '<div class="cc-details__img"><img src="'+pick[i]+'" alt="'+copy[i].h+'" loading="lazy"></div>'+
        '<div class="cc-details__h">'+copy[i].h+'</div>'+
        '<div class="cc-details__p">'+copy[i].p+'</div>'+
      '</div>';
    }
    block.innerHTML=inner;
    var ref=document.querySelector('.cc-keyfeat')||document.querySelector('.cc-acc-wrap');
    if(ref && ref.parentNode){ ref.parentNode.insertBefore(block, ref.nextSibling); }
    else { infoWrap.appendChild(block); }
  }
  function maybe(){ if(window.matchMedia('(max-width:767px)').matches) init(); }
  if(document.readyState!=='loading') maybe(); else document.addEventListener('DOMContentLoaded', maybe);
  try{ var mq=window.matchMedia('(max-width:767px)'); if(mq.addEventListener) mq.addEventListener('change', maybe); }catch(e){}
  setTimeout(maybe,1600); setTimeout(maybe,3600);
})();

/* === MOBIEL PDP: top herbouw naar goedgekeurd ontwerp (<=767px) — 30 sep 2026 === cc-mobile-toprebuild */
(function(){
  function init(){
    if(window.__ccTop) return;
    if(!window.matchMedia('(max-width:767px)').matches) return;
    if(!document.querySelector('#shopify-section-product-template-1')) return;
    var meta=document.querySelector('.product-single__meta');
    var title=document.querySelector('.product-single__title');
    if(!meta||!title) return;
    window.__ccTop=true;

    // 1. kleur uit de titel halen ("Empower Seamless Leggings, Jet Black" -> "Empower Seamless Leggings")
    var full=title.textContent.trim();
    var colorName='';
    if(/,/.test(full)){
      var idx=full.lastIndexOf(',');
      colorName=full.slice(idx+1).trim();
      title.textContent=full.slice(0,idx).trim();
    }

    // 2. kleur-label + swatches boven de naam
    var curHandle=(location.pathname.split('/products/')[1]||'').split('?')[0].split('/')[0];
    var block=document.createElement('div'); block.className='cc-top-colour';
    var lbl=document.createElement('div'); lbl.className='cc-top-colour__lbl';
    lbl.textContent = colorName ? ('Colour · '+colorName) : 'Colour';
    block.appendChild(lbl);
    var built=[];

    // PRIMAIR: betrouwbare server-side kleur-siblings (custom.color_siblings) uit #cc-color-siblings
    var sibEl=document.getElementById('cc-color-siblings');
    if(sibEl){
      try{
        var sibs=JSON.parse(sibEl.textContent||'[]');
        sibs.forEach(function(s){
          var slug=(s.url||'').split('?')[0].split('/').pop();
          var act = s.current===true || slug===curHandle;
          if(act && s.label){ colorName=s.label; }  // nette casing uit metafield-label (bv. "Hurricane Grey")
          built.push({href:s.url||'#', bg:s.hex||'#cccccc', ttl:s.label||'', active: act});
        });
        if(colorName){ lbl.textContent='Colour · '+colorName; }
      }catch(e){}
    }

    // FALLBACK: swatch-lijst uit de DOM (alleen die van het HUIDIGE product)
    if(!built.length){
      var swLists=[].slice.call(document.querySelectorAll('ul.product-swatches, .product-swatches--card'));
      var swList=swLists.filter(function(ul){
        return [].slice.call(ul.querySelectorAll('a')).some(function(a){ return (a.getAttribute('href')||'').split('?')[0].split('/').pop()===curHandle; });
      })[0];
      if(swList){
        [].forEach.call(swList.querySelectorAll('.product-swatches__item, li'), function(li){
          var a=li.querySelector('a'); if(!a) return;
          var sp=li.querySelector('.product-swatches__swatch, [style*="--bg"], span');
          var bg='';
          if(sp){ bg=(getComputedStyle(sp).getPropertyValue('--bg')||'').trim() || getComputedStyle(sp).backgroundColor; }
          var href=a.getAttribute('href')||'#';
          var ttl=li.getAttribute('data-original-title')||li.getAttribute('title')||a.getAttribute('title')||'';
          var slug=href.split('?')[0].split('/').pop();
          built.push({href:href,bg:bg||'#cccccc',ttl:ttl,active: slug===curHandle});
        });
      }
    }
    if(!built.length){
      // laatste redmiddel: enkele huidige-kleur swatch
      var cur=document.querySelector('.selector-wrapper .product-swatches__swatch, .selected-value .product-swatches__swatch, [data-option-name="color"] .product-swatches__swatch');
      var cbg=''; if(cur){ cbg=(getComputedStyle(cur).getPropertyValue('--bg')||'').trim() || getComputedStyle(cur).backgroundColor; }
      if(cbg){ built=[{href:'javascript:void(0)', bg:cbg, ttl:colorName||'', active:true}]; }
    }
    // huidige kleur (= getoonde plaatje) altijd vooraan zetten (stabiele sort behoudt rest-volgorde)
    if(built.length>1){ built.sort(function(a,b){ return (b.active?1:0)-(a.active?1:0); }); }
    if(built.length){
      var row=document.createElement('div'); row.className='cc-top-swatches';
      row.innerHTML=built.map(function(b){
        return '<a class="cc-sw'+(b.active?' is-active':'')+'" href="'+b.href+'" title="'+String(b.ttl).replace(/"/g,'&quot;')+'" aria-label="'+String(b.ttl).replace(/"/g,'&quot;')+'" style="background:'+b.bg+'"></a>';
      }).join('');
      block.appendChild(row);
    }
    // in de server-side gereserveerde slot plaatsen (voorkomt layout-shift/CLS); fallback = vóór meta
    var ccSlot=document.querySelector('.cc-top-colour-slot');
    if(ccSlot){ ccSlot.appendChild(block); } else { meta.parentNode.insertBefore(block, meta); }

    // oude color-box verbergen
    var colorBox=[].slice.call(document.querySelectorAll('.selector-wrapper')).filter(function(w){return /^Colou?r/i.test((w.innerText||'').trim());})[0];
    if(colorBox){ colorBox.style.setProperty('display','none','important'); }

    // 3. korte beschrijving onder de prijs (uit meta-description, naam-herhaling weghalen)
    var md=(document.querySelector('meta[name="description"]')||{}).content||'';
    if(md){
      var baseName=title.textContent.trim();
      if(baseName && md.indexOf(baseName)===0){
        var dot=md.indexOf('. ');
        if(dot>-1 && dot<baseName.length+40) md=md.slice(dot+2).trim();
      }
      if(md){
        var d=document.createElement('div'); d.className='cc-top-desc'; d.textContent=md;
        meta.parentNode.insertBefore(d, meta.nextSibling);
      }
    }

    // 3b. "VAT included" naast de prijs
    var priceEl=document.querySelector('.product-single__price');
    if(priceEl && !priceEl.parentNode.querySelector('.cc-vat')){
      var vat=document.createElement('span'); vat.className='cc-vat'; vat.textContent='VAT included';
      priceEl.parentNode.insertBefore(vat, priceEl.nextSibling);
    }

    // 4. GEEN "Size"/"Size chart" head boven de pill (op verzoek weg, net als ON — size chart zit in de kaart)

    // 5. delivery-regel verbergen (staat niet in het ontwerp)
    var dt=document.querySelector('.product-delivery-text');
    if(dt){ dt.style.setProperty('display','none','important'); }
  }
  function maybe(){ if(window.matchMedia('(max-width:767px)').matches) init(); }
  if(document.readyState!=='loading') maybe(); else document.addEventListener('DOMContentLoaded', maybe);
  try{ var mq=window.matchMedia('(max-width:767px)'); if(mq.addEventListener) mq.addEventListener('change', maybe); }catch(e){}
  setTimeout(maybe,1600); setTimeout(maybe,3400);
})();

/* === FIX: submenu (cp-panel) X sluit de drawer niet — triggert de werkende hoofd-X — 1 okt 2026 === cc-drawer-close-fix */
(function(){
  document.addEventListener('click', function(e){
    var t = e.target && e.target.closest ? e.target.closest('.cp-panel-close') : null;
    if(!t) return;
    var main = document.querySelector('.drawer__close.js-drawer-close') || document.querySelector('.js-drawer-close');
    if(main && main!==t){ setTimeout(function(){ main.click(); }, 0); }
  }, true);
})();

/* === Gratis-verzending-balk winkelmand (NL vanaf €100) — 15 okt 2026 === cc-ship-bar */
(function(){
  var LIMIT=10000;
  function fmt(c){return '€'+(c/100).toFixed(2);}
  function render(cart){
    var box=document.querySelector('.mini-cart-wapper .bottom-cart-data');
    if(!box) return;
    var el=box.querySelector('.cc-ship-bar');
    if(!el){el=document.createElement('div');el.className='cc-ship-bar';el.innerHTML='<p class="cc-ship-bar__t"></p><div class="cc-ship-bar__track"><div class="cc-ship-bar__fill"></div></div>';box.insertBefore(el,box.firstChild);}
    var t=cart.total_price||0;
    el.style.display=cart.item_count?'':'none';
    el.querySelector('.cc-ship-bar__t').innerHTML=t>=LIMIT?'<b>Free delivery</b> in the Netherlands unlocked':'Add <b>'+fmt(LIMIT-t)+'</b> for free delivery in the Netherlands';
    el.querySelector('.cc-ship-bar__fill').style.width=Math.min(100,t/LIMIT*100)+'%';
  }
  function update(){fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(render).catch(function(){});}
  document.addEventListener('DOMContentLoaded',update);
  if(window.jQuery){jQuery(document).on('ajaxComplete',function(e,x,s){if(s&&s.url&&/\/cart/.test(s.url)&&!/cart\.js/.test(s.url))update();});}
  var _f=window.fetch;window.fetch=function(){var p=_f.apply(this,arguments);try{var u=String(arguments[0]&&arguments[0].url||arguments[0]);if(/\/cart\/(add|change|update|clear)/.test(u))p.then(function(){setTimeout(update,300);});}catch(e){}return p;};
})();
